module.exports = __webpack_public_path__ + "img/upper pocket width welt.f1e941fe.png";